import { Box, Radio } from '@ksyos/design-system';
import type { FormContextProps } from '../elements/formContext';
import type { IFormGroupFieldProps } from './FormGroupField';
import { FormContextConsumer } from '../elements/formContext';
import { FormGroupField } from './FormGroupField';

interface IRadioItem {
    disabled?: boolean;
    id: string;
    label: string;
    value: any;
}

interface IInputRadioGroupProps {
    disableGroup?: boolean;
    onChange: (value: string) => void;
    radioItems: IRadioItem[];
    value: any;
}

function InputRadioGroupInner(props: FormContextProps<IInputRadioGroupProps & IFormGroupFieldProps>) {
    return (
        <FormContextConsumer {...props}>
            {(properties) => (
                <Box
                    display="flex"
                    flexDirection="column"
                    gap={2}
                >
                    {props.radioItems.map((radioItem) => (
                        <Radio
                            checked={radioItem.value === properties.value}
                            disabled={properties.disableGroup || radioItem.disabled}
                            id={radioItem.id}
                            key={radioItem.label}
                            label={radioItem.label}
                            name={(props as any).fieldKey}
                            onChange={async (e) => {
                                if (e.target.checked) {
                                    properties.onChange(radioItem.value);
                                }
                            }}
                        />
                    ))}
                </Box>
            )}
        </FormContextConsumer>
    );
}

export function InputRadioGroup(props: FormContextProps<IInputRadioGroupProps & IFormGroupFieldProps>) {
    return (
        <FormGroupField {...props}>
            <InputRadioGroupInner {...props} />
        </FormGroupField>
    );
}
